import React, { useState, useEffect } from 'react';
import { menuItemService } from '../../services/api';

function MenuItemsManagement() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ label: '', url: '', icon: '', location: 'header', sort_order: 0, parent_id: '', is_active: true, open_new_tab: false });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => { loadItems(); }, []);

  const loadItems = async () => {
    setLoading(true);
    try { setItems(await menuItemService.index()); } catch (e) { console.error(e); }
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = { ...form, parent_id: form.parent_id ? parseInt(form.parent_id) : null };
      if (editingId) await menuItemService.update(editingId, data);
      else await menuItemService.store(data);
      setShowForm(false); setEditingId(null); setForm({ label: '', url: '', icon: '', location: 'header', sort_order: 0, parent_id: '', is_active: true, open_new_tab: false });
      loadItems();
    } catch (error) { alert('Error saving menu item'); }
  };

  const handleEdit = (item) => { setForm({ ...item, parent_id: item.parent_id || '' }); setEditingId(item.id); setShowForm(true); };
  const handleDelete = async (id) => { if (!window.confirm('Delete?')) return; try { await menuItemService.destroy(id); loadItems(); } catch (e) { alert('Error'); } };

  const parents = items.filter(i => !i.parent_id);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-slate-100">Menu Items (Navigation)</h2>
        <button onClick={() => { setShowForm(true); setEditingId(null); }} className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition">+ Add Menu Item</button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="bg-slate-900 border border-slate-800 rounded-xl p-6 mb-6 space-y-4 max-w-2xl shadow-sm">
          <h3 className="font-bold text-lg text-slate-100">{editingId ? 'Edit' : 'New'} Menu Item</h3>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1">
              <label className="text-[10px] uppercase text-slate-500 font-semibold">Label</label>
              <input required placeholder="Link text" value={form.label} onChange={e => setForm({ ...form, label: e.target.value })} className="w-full bg-slate-950 border border-slate-700 rounded-lg px-3 py-2 text-sm text-slate-200 focus:outline-none focus:border-red-500" />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] uppercase text-slate-500 font-semibold">URL</label>
              <input required placeholder="/about" value={form.url} onChange={e => setForm({ ...form, url: e.target.value })} className="w-full bg-slate-950 border border-slate-700 rounded-lg px-3 py-2 text-sm text-slate-200 focus:outline-none focus:border-red-500" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1">
              <label className="text-[10px] uppercase text-slate-500 font-semibold">Parent Item</label>
              <select value={form.parent_id} onChange={e => setForm({ ...form, parent_id: e.target.value })} className="w-full bg-slate-950 border border-slate-700 rounded-lg px-3 py-2 text-sm text-slate-200 focus:outline-none focus:border-red-500">
                <option value="">No Parent (Top Level)</option>
                {parents.map(p => <option key={p.id} value={p.id}>{p.label}</option>)}
              </select>
            </div>
            <div className="space-y-1">
              <label className="text-[10px] uppercase text-slate-500 font-semibold">Location</label>
              <input placeholder="header/footer" value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} className="w-full bg-slate-950 border border-slate-700 rounded-lg px-3 py-2 text-sm text-slate-200 focus:outline-none focus:border-red-500" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1">
              <label className="text-[10px] uppercase text-slate-500 font-semibold">Sort Order</label>
              <input type="number" placeholder="0" value={form.sort_order} onChange={e => setForm({ ...form, sort_order: parseInt(e.target.value) || 0 })} className="w-full bg-slate-950 border border-slate-700 rounded-lg px-3 py-2 text-sm text-slate-200 focus:outline-none focus:border-red-500" />
            </div>
            <div className="flex flex-col justify-center gap-2">
              <label className="flex items-center gap-2 text-sm text-slate-400 cursor-pointer"><input type="checkbox" checked={form.is_active} onChange={e => setForm({ ...form, is_active: e.target.checked })} className="rounded bg-slate-950 border-slate-700 text-red-600 focus:ring-red-500" /> Active</label>
              <label className="flex items-center gap-2 text-sm text-slate-400 cursor-pointer"><input type="checkbox" checked={form.open_new_tab} onChange={e => setForm({ ...form, open_new_tab: e.target.checked })} className="rounded bg-slate-950 border-slate-700 text-red-600 focus:ring-red-500" /> Open in New Tab</label>
            </div>
          </div>
          <div className="flex gap-2 pt-2">
            <button type="submit" className="flex-1 bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-red-700 transition">{editingId ? 'Update' : 'Save'}</button>
            <button type="button" onClick={() => setShowForm(false)} className="flex-1 bg-slate-800 text-slate-300 px-4 py-2 rounded-lg text-sm font-medium hover:bg-slate-700 transition">Cancel</button>
          </div>
        </form>
      )}

      <div className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden shadow-sm">
        <table className="min-w-full divide-y divide-slate-800">
          <thead className="bg-slate-950">
            <tr>
              <th className="px-6 py-3 text-left text-[10px] font-bold text-slate-500 uppercase tracking-wider">Label</th>
              <th className="px-6 py-3 text-left text-[10px] font-bold text-slate-500 uppercase tracking-wider">URL</th>
              <th className="px-6 py-3 text-left text-[10px] font-bold text-slate-500 uppercase tracking-wider">Location</th>
              <th className="px-6 py-3 text-left text-[10px] font-bold text-slate-500 uppercase tracking-wider">Order</th>
              <th className="px-6 py-3 text-left text-[10px] font-bold text-slate-500 uppercase tracking-wider">Status</th>
              <th className="px-6 py-3 text-left text-[10px] font-bold text-slate-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800">
            {items.map((i) => (
              <tr key={i.id} className="hover:bg-slate-800/40 transition">
                <td className="px-6 py-4 text-sm font-medium text-slate-300">
                  {i.label} {i.parent_id && <span className="ml-1 text-[10px] text-slate-500 uppercase tracking-tighter">(child)</span>}
                </td>
                <td className="px-6 py-4 text-sm text-slate-400">{i.url}</td>
                <td className="px-6 py-4 text-sm text-slate-400 font-mono">{i.location}</td>
                <td className="px-6 py-4 text-sm text-slate-400">{i.sort_order}</td>
                <td className="px-6 py-4 text-sm">
                  <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${i.is_active ? 'bg-red-600/10 text-red-500 border border-red-600/20' : 'bg-red-600/10 text-red-500 border border-red-600/20'}`}>
                    {i.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="px-6 py-4 text-sm space-x-3">
                  <button onClick={() => handleEdit(i)} className="text-red-500 hover:text-red-400 transition font-medium">Edit</button>
                  <button onClick={() => handleDelete(i.id)} className="text-red-500 hover:text-red-400 transition font-medium">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {items.length === 0 && (
          <div className="text-center py-12 text-slate-500 text-sm">No menu items found.</div>
        )}
      </div>
    </div>
  );
}

export default MenuItemsManagement;
